import React, {useContext, useState, useEffect} from 'react';
import { useQuery } from '@apollo/client';
import { View, Text, Pressable } from 'react-native';
import styled from 'styled-components/native';

import {
  MainContainer,
  ContentContainer
} from 'app/src/elements';
import Input from 'app/src/elements/inputs';
import { Button, ButtonGroup, ButtonContainer } from 'app/src/elements/buttons';
import AuthContext from 'app/src/contexts/AuthContext';

import { SELLER_USER_SELECT_OPTIONS } from './queries';

const AssignToUsers = props => {
  const { selectedSellerUsers, setSelectedSellerUsers } = props;
  const { user } = useContext(AuthContext);

  const [sellerUserSelectOptions, setSellerUserSelectOptions] = useState([]);
  const { data } = useQuery(SELLER_USER_SELECT_OPTIONS);

  return (
    <View style={{maxWidth: '60vw'}}>
      <Input.MultiSelect
        selected={selectedSellerUsers}
        setSelected={setSelectedSellerUsers}
        resourceType="Users"
        resources={data?.sellerUsers?.map(sellerUser => {
          return { id: sellerUser.id, name: sellerUser.fullName}
        })}
      />
    </View>
  )
}

export default AssignToUsers;
